import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import axios from "../../api/axios";
import { getArrearsDetails } from "../../api/endPoints";
import { nbfArrearAmount, nbfSupplier } from "../../api/restApi";
import { useSelector } from "react-redux";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function Supplier() {
  const customerId = useSelector((state) => state.currentUser.name);
  const role = useSelector((state) => state.currentUser.role);
  const [arrear, setArrear] = useState(0);
  const [pieData, setPieData] = useState({
    labels: [],
    datasets: [
      {
        label: "Arrear: ",
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      },
    ],
  });
  var dynamicColors = function () {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
  };
  const setPie = (data) => {
    console.log(data)
    let oldData = pieData;
    // arrange data by arrear amount
    data.sort((a, b) => {
      return b.payable - a.payable;
    });

    data.forEach((element) => {
      if (element.payable === 0 || element.payable === "0") {
        return;
      }
      oldData.labels.push(element.name);
      oldData.datasets[0].data.push(element.payable);
      oldData.datasets[0].backgroundColor.push(dynamicColors());
      oldData.datasets[0].borderColor.push(dynamicColors());
    });
    setPieData(oldData);
    console.log(pieData);
  };
  useEffect(() => {
    const fetchArrear = async () => {
      if(role==='cs'){
        
    //   const response = await nbfArrearAmount(customerId)
    //   setArrear(response.arrearAmount);
      // setPie(response.data.paymentData);
      }else{
    //   const response = await axios.get(getArrearsDetails);
      const supplierRes=await nbfSupplier()
      const totalPayable = supplierRes.map((el) => Number(el.payable))
                                .reduce((acc, curr) => acc + curr, 0);
      setArrear(totalPayable);
      setPie(supplierRes);
      }
    };
    fetchArrear();
  }, []);

  console.log(arrear)

  return (
    <div>
      <Stack alignItems="center" spacing={1} marginTop="0rem">
        <Box sx={{ flexGrow: 0 }}>
          <Grid item xs={24} md={6}>
            <Card
              alignItems="start"
              sx={{
                width: "100%",
                marginTop: "0rem",
                "@media (min-width: 300px)": {
                  width: 350, // Set the width to 100% for mobile view
                },
                "@media (min-width: 650px)": {
                  width: 650, // Set the width to 650px for screens wider than 650px
                },
              }}
            >
              <CardContent>
                <Stack alignItems="center">
                  <h2>Suppliers Payable: {arrear?.toLocaleString()}</h2>
                </Stack>
                <div>
                  <Doughnut
                    data={pieData}
                    height="500px"
                    width="450px"
                    options={{
                      maintainAspectRatio: false,
                      plugins: {
                        legend: {
                          onClick: (e) => e.stopPropagation(),
                        },
                      },
                    }}
                  />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Box>
      </Stack>
    </div>
  );
}
